import React, { Fragment, Component } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../../../helpers/ui/CustomSelect";
import { YearSelect, MonthSelect } from "../../../../helpers/ui/YearSelect";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear() + 30,
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

const createMonthOptions = () => {
  var months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return months.map(function (month, i) {
    var newObj = {};
    newObj["label"] = month;
    newObj["value"] = ++i;

    return newObj;
  });
};

class CreateView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {},
      yearOptions: createYearOption(new Date().getFullYear()),
      monthOptions: createMonthOptions(),
    };
  }

  submitData = async () => {
    await this.createBloc.fetchCreate(this.state.dataForm);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        ...values,
      },
      confirm: true,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Card className="">
            <CardBody style={{ height: "350px" }}>
              <CardTitle>Tambah Data Periode Struktur Organisasi</CardTitle>
              <CardSubtitle className="mb-3">
                Setiap isian yang bertanda (
                <span className="text-danger">*</span>) adalah wajib diisi.
              </CardSubtitle>
              <hr />
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
              >
                <Row className="mb-3">
                  <label htmlFor="no_sk" className="col-md-3 col-form-label">
                    Pilih Periode <span className="text-danger">*</span>
                  </label>
                  {/* <Col md="2">
                    <MonthSelect
                      name="position_period_month"
                      errorMessage="Pilih Periode"
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Periode"
                    />
                  </Col> */}
                  <Col md="2">
                    <CustomSelect
                      name="position_period_month"
                      errorMessage="Pilih Periode"
                      options={this.state.monthOptions}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Periode"
                      defaultValue={new Date().getMonth() + 1}
                    />
                  </Col>
                  <Col md="2">
                    <CustomSelect
                      name="position_period_year"
                      errorMessage="Pilih Tahun"
                      options={this.state.yearOptions}
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Tahun"
                      defaultValue={new Date().getFullYear()}
                    />
                  </Col>

                  {/* <Col md="2">
                    <YearSelect
                      name="position_period_year"
                      errorMessage="Pilih Tahun"
                      validate={{ required: { value: true } }}
                      placeholder="Pilih Tahun"
                    />
                  </Col> */}
                </Row>

                <Row className="mb-3">
                  <Col md="3"></Col>
                  <Col md="9">
                    <Link to="/kepegawaian/strukturorganisasi.html">
                      <Button color="danger">
                        <i className="uil-arrow-left"></i> Kembali
                      </Button>
                    </Link>{" "}
                    <Button color="success" type="submit">
                      <i className="uil-arrow-up-right"></i> Simpan Data
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect to="/kepegawaian/strukturorganisasi.html" />
        ) : null}
      </Fragment>
    );
  }
}

export default CreateView;
